import React from "react";
import { Page } from "@shopify/polaris";

export function HomePage() {
    return <Page fullWidth title="Home"></Page>;
}
